import type { Slot, PollInsights } from "./types";

/**
 * Retourne les slot IDs ordonnés par popularité décroissante (yes desc, puis
 * maybe desc, puis ordre chronologique stable). Source unique pour le filtre
 * "Top N" et l'overview "Vue d'ensemble".
 */
export function slotRanking(slots: Slot[], insights: PollInsights): string[] {
  const scoreByIndex = new Map<string, number>();
  for (const s of insights.scores) scoreByIndex.set(s.slotId, 0);
  for (const sc of insights.scores) {
    // tri primaire: yes ; tie-breaker secondaire: maybe ; tertiaire: ordre
    scoreByIndex.set(sc.slotId, sc.yes * 1000 + sc.maybe);
  }
  return [...slots]
    .map((s, i) => ({ s, i, score: scoreByIndex.get(s.id) ?? 0 }))
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return a.i - b.i;
    })
    .map(({ s }) => s.id);
}

/**
 * Sélection des N meilleurs slots, restitués dans l'ordre chronologique
 * (lecture naturelle dans la table). Garantit l'inclusion du winner.
 */
export function topSlotIds(
  slots: Slot[],
  insights: PollInsights,
  n: number,
): Set<string> {
  const ranked = slotRanking(slots, insights);
  const picked = new Set(ranked.slice(0, Math.max(1, n)));
  if (insights.winnerSlotId) picked.add(insights.winnerSlotId);
  return picked;
}
